SA.logout = function() {
    if (!SA.AppController.sessionReplacedOrExpired() && (SA.User || SA.Institution)) {
        Ext.getBody().setStyle('visibility', 'hidden');

        SA.Ajax.request({
            method: 'logout',
            resource: 'user',

            failure: redirect,
            success: redirect
        });
    }
    else {
        redirect();
    }

    function redirect() {
        SA.Storage.clear();

        window.location = 'login.html';
    }
};